import {
  CaretDownOutlined,
  CaretRightFilled,
  CaretRightOutlined,
  CaretUpFilled,
  CloseCircleTwoTone,
  CloseOutlined,
  DesktopOutlined,
  DropboxOutlined,
  EditOutlined,
  EnvironmentOutlined,
  ExclamationCircleFilled,
  EyeOutlined,
  FileImageOutlined,
  FileOutlined,
  FilterOutlined,
  LaptopOutlined,
  LeftOutlined,
  LoadingOutlined,
  LogoutOutlined,
  MinusOutlined,
  MoreOutlined,
  NotificationOutlined,
  PercentageOutlined,
  PieChartOutlined,
  PlusOutlined,
  ProductOutlined,
  ReloadOutlined,
  RightOutlined,
  SaveFilled,
  SaveOutlined,
  SaveTwoTone,
  SettingOutlined,
  ShoppingCartOutlined,
  TeamOutlined,
  UserAddOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  WarningOutlined,
  CheckOutlined,
  RetweetOutlined,
} from '@ant-design/icons';
export const icons = {
  CaretRightOutlined,
  EnvironmentOutlined,
  RightOutlined,
  LeftOutlined,
  LaptopOutlined,
  NotificationOutlined,
  PieChartOutlined,
  DesktopOutlined,
  UserOutlined,
  TeamOutlined,
  FileOutlined,
  ShoppingCartOutlined,
  WarningOutlined,
  ProductOutlined,
  PercentageOutlined,
  DropboxOutlined,
  UsergroupAddOutlined,
  SettingOutlined,
  LogoutOutlined,
  FilterOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined,
  SaveOutlined,
  SaveTwoTone,
  CloseCircleTwoTone,
  ExclamationCircleFilled,
  SaveFilled,
  MinusOutlined,
  LoadingOutlined,
  FileImageOutlined,
  CloseOutlined,
  CaretUpFilled,
  CaretRightFilled,
  ReloadOutlined,
  UserAddOutlined,
  CaretDownOutlined,
  MoreOutlined,
  CheckOutlined,
  RetweetOutlined,
};
